import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 12.5l-5 -3l5 -3l5 3v5.5l-5 3z","key":"svg-0"}],["path",{"d":"M11 9.5v5.5l5 3","key":"svg-1"}],["path",{"d":"M16 12.545l5 -3.03","key":"svg-2"}],["path",{"d":"M7 9h-5","key":"svg-3"}],["path",{"d":"M7 12h-3","key":"svg-4"}],["path",{"d":"M7 15h-1","key":"svg-5"}]]

const IconCubeSend = createReactComponent('outline', 'cube-send', 'CubeSend', __iconNode);

export default IconCubeSend;